import WEB_PATHS from '@constants/webPaths';
import TwoColFullScreen from '@layouts/v2/twocolfullscreen.layout';
import ButtonV2, {
  ButtonV2Rounded,
  ButtonV2Size,
  ButtonV2Style,
} from '@ui-kit/v2/Button';
import classNames from 'classnames';
import useTranslation from 'src/i18n/useTranslation';
import Image from 'next/image';

const SignupSuccess = (props) => {
  const { router } = props;
  const { t } = useTranslation();
  return (
    <TwoColFullScreen>
      <div className="relative flex h-full flex-col items-center lg:justify-center">
        <div className="z-10 flex flex-1 flex-col lg:flex-initial">
          <div className="flex flex-1 flex-col items-center justify-center whitespace-pre-line px-6 text-center lg:flex-initial lg:items-start lg:p-0">
            <p className="mb-4 text-h5 font-bold lg:text-h3">
              {t('signupsuccess.title')}
            </p>
            <p className="text-p1 font-semibold text-grayv2-600 lg:text-subheadingv2 lg:text-grayv2-900">
              {t('signupsuccess.subtitle')}
            </p>
          </div>

          <div className="p-6 lg:pl-0">
            <ButtonV2
              variantClassName={classNames(
                ButtonV2Rounded.large,
                ButtonV2Style.primary,
                ButtonV2Size.medium,
                'w-full lg:w-fit h-fit',
              )}
              buttonProps={{
                type: 'submit',
                onClick: () => router.push(WEB_PATHS.DASHBOARD),
              }}
            >
              {t('continue')}
            </ButtonV2>
          </div>
        </div>
        <div className="lg:hidden">
          <Image
            layout="fill"
            objectFit="cover"
            src="/assets/agreement-background.svg"
            alt="agreement image"
            className="absolute z-0"
          />
        </div>
      </div>
    </TwoColFullScreen>
  );
};

export default SignupSuccess;
